export const COMPANY_TYPES = [
  "Hongkong Funded: 港资（企业）/ 香港投资",
  "Taiwan Funded: 台资（企业）/ 台湾投资",
  "Private Enterprise: 民营企业",
  "Joint Venture: 合资企业",
  "Individual Proprietorship: 个体工商户 / 独资企业",
];

export const CURRENCY_TYPES = ["CNY", "USD"];

export const SUPPLIER_CERTIFICATES = [
  "ICTI",
  "BSCI",
  "SEDEX",
  "SMETA",
  "BETTER WORK",
  "FCCA",
  "FSC",
  "ISO14001",
  "SA8000",
  "ISO9001",
  "Global Recycled Standard 4.0 (GRS4.0)",
  "Global Security Verification (GSV)",
  "消防",
  "环评",
];
